/* eslint-disable no-console */
import { log, supabase } from ".";

export const updateCliente = async (updatedData) => {
  try {
    // Backstop (decisión de Ignacio, 2026-10-07: ningún cliente sin categoría). Rechaza SOLO si
    // el caller manda `categoria` explícitamente vacía/null — si la llave no viene en el PATCH,
    // la categoría existente no se toca (PATCH parcial real, no hay riesgo de nulificar sin
    // querer). Último candado antes del UPDATE, nunca en silencio (10.177).
    if ("categoria" in updatedData && !updatedData.categoria) {
      throw new Error("updateCliente: la categoría es obligatoria — no se puede guardar vacía");
    }
    const id = updatedData.id;
    delete updatedData.id; // Eliminar id del updatedData ya que se usa en el eq
    updatedData.lastupdate = new Date().toISOString(); // Add current timestamp to lastupdate
    const { data, error } = await supabase.update("clientes", updatedData, id);

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    log.error("updateCliente", error);
    throw error;
  }
};
